// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2vuVD","messages":"Chat_messages__240XK","dateDivider":"Chat_dateDivider__3YSTS"};